function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 812 812",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.93871,-9.93871,9.93871,9.93871,-413.187,202.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.36,51.505L59.36,59.301L31.011,59.301L31.011,48.271L48.002,48.271C48.006,48.293 48.011,48.315 48.015,48.336L47.995,48.233C47.369,44.948 45.785,41.811 43.244,39.271C36.492,32.519 25.529,32.519 18.777,39.271C12.025,46.023 12.025,56.987 18.777,63.739C22.153,67.115 26.582,68.803 31.011,68.803L31.011,79.854C23.752,79.854 16.494,77.088 10.961,71.555C-0.105,60.489 -0.105,42.521 10.961,31.455C22.026,20.389 39.995,20.389 51.061,31.455C55.77,36.164 58.475,42.123 59.156,48.271C59.231,48.838 59.284,49.407 59.317,49.977C59.319,50.018 59.322,50.059 59.324,50.1L59.327,50.157L59.328,50.188L59.332,50.257C59.337,50.376 59.342,50.494 59.346,50.612C59.349,50.719 59.352,50.827 59.354,50.934C59.356,51.021 59.357,51.107 59.358,51.194C59.359,51.297 59.36,51.401 59.36,51.505ZM48.288,50.665C48.298,50.874 48.305,51.083 48.307,51.292C48.305,51.083 48.298,50.874 48.288,50.665ZM48.26,50.208C48.266,50.286 48.271,50.364 48.276,50.442C48.271,50.364 48.266,50.286 48.26,50.208ZM48.254,50.135L48.256,50.157L48.254,50.135L48.252,50.102L48.254,50.135ZM48.054,48.555L48.06,48.585L48.054,48.555ZM48.026,48.399L48.03,48.421L48.04,48.472C48.035,48.447 48.031,48.423 48.026,48.399Z",
    style: {
      fill: "rgb(104,134,216)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElogo3);
export default __webpack_public_path__ + "static/media/elogo3.014530c6885232052914c9cbb531e338.svg";
export { ForwardRef as ReactComponent };